import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { AutoCompleteProps } from '@benefitflow/designsystem/dist/components/AutoComplete/AutoComplete.types';

import { getLabel } from '../helpers';
import { selectListsDetailPage } from 'app/containers/ListsPage/containers/ListsDetailPage/selectors';

export const useOptions = () => {
	const { cityStateSearchOptions } = useSelector(selectListsDetailPage);

	const options = useMemo<AutoCompleteProps<any>['options']>(
		() => cityStateSearchOptions?.map((data) => ({ value: data.searchValue, label: getLabel(data), data })) ?? [],
		[cityStateSearchOptions]
	);

	return options;
};
